export const API_URL = "https://api-test.dream4.net";
export const REACT_APP_SECRET_KEY = "secret"
export const REACT_APP_SITE_KEY = "6Lc3y1knAAAAAGLhRO3XZHV1ZPkJLET-9otTCC6S"
// export const WS_URL = "https://ws.dream4.net";
export const WS_URL = "https://ws-test.dream4.net";
